
<div class="header-PS">
<label class="label-PS" *ngIf="!modeRP">{{ situations[0].libelleCodeCivilite}} {{ situations[0].nom}} {{ situations[0].prenom}}</label>
<label class="lbl-secondary" *ngIf="!modeRP">{{ situations[0].libelleTypeIdentificationNational}} : {{ situations[0].numIdentificationNational}}{{ situations[0].cleIdentificationNational}}</label>
<label class="label-PS" *ngIf="modeRP">{{ situations[0].libelleCiviliteRP}} {{ situations[0].nomRP}} {{ situations[0].prenomRP}}</label>
<label class="lbl-secondary" *ngIf="modeRP">{{ situations[0].RPPSrp}}</label>
</div>
<h2 mat-dialog-title *ngIf="!modeRP">Choisissez une situation</h2>
<h2 mat-dialog-title *ngIf="modeRP">Choisissez un titulaire</h2>
<mat-dialog-content>
  <mat-list>
    <mat-list-item
      *ngFor="let situation of situations"
      (click)="selectSituation(situation)"
      class="selectable-item"
    >
      <!-- <div mat-line>ID JFSE : {{ situation.idJfse }}</div> -->
        <div *ngIf="situation.idJfse > 0 && !modeRP">
          <div mat-line >{{ situation.raisonSociale }}</div>
          <div mat-line class="secondary">Structure : {{ situation.numIdentificationStructure }}</div>
        </div>
        <div *ngIf="situation.idJfse == 0 && !modeRP" #situationinconnu>
          <div mat-line class="sit-inconnu">{{ situation.raisonSociale }}</div>
          <div mat-line class="secondary">La situation de facturation n'est pas configurée</div>
        </div>
        <!-- mode RP choix RP -->
        <div *ngIf="situation.idJfse > 0 && modeRP && situation.activation == 1">
          <div mat-line >{{ situation.nom }} {{ situation.prenom }}</div>
          <div mat-line class="secondary">N° facturation : {{ situation.numIdentificationNational }}</div>
        </div>
        <div *ngIf="situation.idJfse > 0 && modeRP && situation.activation == 0" #situationNonActive>
          <div mat-line class="sit-inconnu">{{ situation.nom }} {{ situation.prenom }}</div>
          <div mat-line class="secondary">N° facturation : {{ situation.numIdentificationNational }}</div>
          <div mat-line class="secondary">La situation remplaçant n'est pas configurée</div>
        </div>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>
<mat-dialog-actions align="end" *ngIf="situationinconnu">
  <button mat-button (click)="close()">Annuler</button>
</mat-dialog-actions>
